export const PRIVATE = 'private';
export const ORGANIZATION = 'organization';
export const SECRET = 'secret';
export const PUBLIC = 'public';

export const DEFAULT_PRIVACY = PRIVATE;
export const PRIVACY_OPTIONS = [PRIVATE, SECRET, PUBLIC];
export const SCHOOL_PRIVACY_OPTIONS = [PRIVATE, ORGANIZATION, SECRET, PUBLIC];

export const READ = 'read';
export const CREATE = 'create';
export const EDIT = 'edit';
export const ADMIN = 'administrator';

export const DEFAULT_PERMISSION = READ;
export const PERMISSION_OPTIONS = [READ, CREATE, EDIT, ADMIN];
export const GLOBAL_PERMISSION_OPTIONS = [READ, CREATE];

export const ANSWER_TYPES = ['SINGLE', 'MULTIPLE', 'HANGMAN', 'FREETEXT'];
export const DEFAULT_ANSWER_TYPE = 'SINGLE';
export const EMPTY_ANSWER_TYPE = 'EMPTY';

export const DEFAULT_TRIGGERS = ['NEXT', 'GO_TO_POINT', 'END'];
export const ANSWER_TRIGGERS = ['ON_ANSWER'];
export const LOCATION_TRIGGERS = ['AT_ARRIVE'];

export const COURSE_TYPE_NOOC = 'nooc';
export const COURSE_TYPE_WEBINAR = 'webinar';
export const COURSE_TYPE_COACHING = 'coaching';
export const COURSE_TYPE_TOOLS = 'tools';

export const ACTIVITY_TYPE_BOOK_EXTENSION = 'book_extension';
export const ACTIVITY_TYPE_GLOBAL_PROJECT = 'global_project';

export const BAIN_SOCIAL_IMPACT_TAGS = [
    {
        value: 'inclusion',
        category: 'social-impact',
    },
    {
        value: 'change-agent',
        category: 'social-impact',
    },
];

export const BAIN_LIFE_CHANGER_TAGS = [
    {
        value: 'family',
        category: 'life-changer',
    },
    {
        value: 'heritage',
        category: 'life-changer',
    },
    {
        value: 'self-realization',
        category: 'life-changer',
    },
    {
        value: 'motivation',
        category: 'life-changer',
    },
];

export const BAIN_EMOTIONAL_TAGS = [
    {
        value: 'wellbeing',
        category: 'emotional',
    },
    {
        value: 'fun',
        category: 'emotional',
    },
    {
        value: 'distinctive',
        category: 'emotional',
    },
    {
        value: 'reward',
        category: 'emotional',
    },
    {
        value: 'attractive',
        category: 'emotional',
    },
    {
        value: 'significant',
        category: 'emotional',
    },
];

export const BAIN_FUNCTIONAL_TAGS = [
    {
        value: 'connect',
        category: 'functional',
    },
    {
        value: 'organizes',
        category: 'functional',
    },
    {
        value: 'integration',
        category: 'functional',
    },
    {
        value: 'timesaver',
        category: 'functional',
    },
    {
        value: 'variety',
        category: 'functional',
    },
    {
        value: 'informs',
        category: 'functional',
    },
    {
        value: 'step-by-step',
        category: 'functional',
    },
];

export const BAIN_TAGS = [
    ...BAIN_EMOTIONAL_TAGS,
    ...BAIN_FUNCTIONAL_TAGS,
    ...BAIN_LIFE_CHANGER_TAGS,
    ...BAIN_SOCIAL_IMPACT_TAGS,
];

export const AVAILIABLE_IMPORT_ENVIRONMENTS = [
    {
        name: 'eduloc',
        url: 'http://www.eduloc.net',
        image: '/img/eduloc.png'
    },
    {
        name: 'dev.eduloc',
        url: 'http://dev.eduloc.net',
        image: '/img/dev-eduloc.png'
    },
    {
        name: 'develop.labylok',
        url: 'https://develop.labylok.com',
        image: '/img/dev-labylok.jpg'
    },
    {
        name: 'labylok',
        url: 'https://www.labylok.com',
        image: '/img/prod-labylok.jpg'
    },
];
